export interface MapExtendedOptions {
	mapId?: string;
	zoom?: number;
	maxZoom?: number;
	draggable?: boolean;
	gestureHandling?: string;
	defaultCenter?: google.maps.LatLng;
	mapStyles?: any;
	styledMapName?: string;
	mapTypeControlStyle?: google.maps.MapTypeControlStyle;
}

export class MapComponent {
	static CustomMarker;
	private _options: MapExtendedOptions;
	private map: google.maps.Map;
	private markers: google.maps.Marker[] = [];
	private items: NodeListOf<Element>;

	constructor(private element: HTMLElement, private dotNetReference: any) {
		this.initMap();
	}

	private initMap() {

		const mapContainer = this.element;
		if (mapContainer != null) {
			const lat = mapContainer.getAttribute('data-lat') ?? '47.07675476507977';
			const lng = mapContainer.getAttribute('data-lng') ?? '16.127801312840482';
			const zoom = mapContainer.getAttribute('data-zoom') ?? '12';
			// data-static: a preview without controls or gestures (a link on top handles the click)
			const isStatic = mapContainer.hasAttribute('data-static');
			const location = { lat: parseFloat(lat), lng: parseFloat(lng) };
			this.map = new google.maps.Map(mapContainer, {
				center: location,
				zoom: parseFloat(zoom),
				...(isStatic && {
					disableDefaultUI: true,
					gestureHandling: 'none',
					keyboardShortcuts: false,
					clickableIcons: false,
				}),
			});

			const pos = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
			const svgMarker = {
				path: 'M23.2,64.6C5.2,38.2,1.8,35.5,1.8,25.7c0.1-13.3,10.8-24.1,24-24 c13.1,0.1,23.7,10.8,23.7,24c0,9.7-3.4,12.4-21.4,38.9c-0.9,1.4-2.8,1.7-4.2,0.8C23.7,65.2,23.4,64.9,23.2,64.6z M25.7,35.8 c5.5,0,10-4.5,10-10.1s-4.5-10.1-10-10.1s-10,4.5-10,10C15.7,31.3,20.2,35.8,25.7,35.8L25.7,35.8z',
				fillColor: '#E0FD2C',
				fillOpacity: 1,
				strokeWeight: 2,
				rotation: 0,
				scale: 0.5,
				anchor: new google.maps.Point(13, 33),
			};

			const marker = new google.maps.Marker({
				position: pos,
				icon: svgMarker,
				map: this.map,
			});

			marker.addListener('click', () => {
				this.dotNetReference?.invokeMethodAsync(
					'MapAssemblyMarkerClick',
					location.lat + ',' + location.lng
				);
			});

			this.markers.push(marker);
		}
	}
}
